import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

class InfoReader extends React.Component {
    constructor() {
        super();
        this.state = {
            data: ['Loading...'],
            update: ['Loading...'],
        };
    }

    componentDidMount() {
        const objThis = this;
        fetch('https://updates.signiant.com/flight-gateway/linux-amzn1.info.json')
            .then((response) => response.json())
            .then((findresponse) => {
                console.log(findresponse.version);
                this.setState({
                    data: findresponse.version.substring(0, 7),
                    update: findresponse.updatedOn.substring(0, 10),
                });
            });
    }

    render() {
        return (
            <div>
                Flight Gateway for <strong>Amazon Linux</strong> <br />
                <br />
                <strong>Current Version</strong>: {this.state.data} <br />
                <strong>Released</strong>: {this.state.update}
            </div>
        );
    }
}

export default withStyles(styles)(InfoReader);
